/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import CommonScrollBar from "../Common/CommonScrollBar";
import { OFFER_SCHEME_URL } from "../Shared/constant";
import { Form, Spinner } from "react-bootstrap";
import CheckValid from "../Common/CheckValid";
import EmptySpaceFieldValid from "../Common/EmptySpaceFieldValid";
import UploadFileIcon from "../../assets/img/Upload-File.svg";
import DeleteIcon from "../../assets/img/remove_file.svg";
import UploadFileAPI from "../../Api/UploadFileAPI";
import { useSelector } from "react-redux";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import CommonToggle from "../Common/CommonToggle";
import DatePicker from "react-datepicker";
import CommonDateTime from "../Common/CommonDateTime";
import CreateOfferSchemeAPI from "../../Api/CreateOfferSchemeAPI";
import EditOfferSchemeAPI from "../../Api/EditOfferSchemeAPI";
import { toast } from "react-toastify";

const CreateOfferCampaigns = () => {
  const today = new Date();
  const [LoaderImage, setLoaderImage] = useState(false);

  const { roomId } = useParams();
  const Navigate = useNavigate();
  const CurrentLocation = useLocation().pathname.split("/")[1];
  const { accessToken, OfferSchemesListing } = useSelector(
    (state) => state.adminReducers,
  );
  const CurrentData_ = OfferSchemesListing?.list?.filter(
    (elm) => elm?.id === roomId,
  )[0];

  const [NotificationState, setNotificationState] = useState({
    Title: "",
    StartDate: "",
    EndDate: "",
    Description: "",
    UploadedImage: "",
    UploadedImageName: "",
    Status: true,
  });

  // ERROR STATES
  const [errorTitle, seterrorTitle] = useState("");
  const [errorDescription, seterrorDescription] = useState("");
  const [errorStartDate, seterrorStartDate] = useState("");
  const [errorEndDate, seterrorEndDate] = useState("");
  const [errorUploadedImage, seterrorUploadedImage] = useState("");

  useEffect(() => {
    if (CurrentLocation === "edit-offer-scheme") {
      setNotificationState({
        ...NotificationState,
        Title: CurrentData_?.card_title,
        Description: CurrentData_?.card_description,
        Status: CurrentData_?.status,
        StartDate: new Date(CurrentData_?.start_date),
        EndDate: new Date(CurrentData_?.end_date),
        UploadedImageName: CurrentData_?.image_name,
        UploadedImage: CurrentData_?.image.split("/")[2],
      });
    }
  }, [CurrentData_]);

  // SELECT START DATE
  const DateStartGet = (date) => {
    if (date === null) {
      setNotificationState({
        ...NotificationState,
        StartDate: "",
        EndDate: "",
      });
      CheckValid(date === null || date === "" ? "" : date, {
        type: "NotificationStartDate",
        error: seterrorStartDate,
      });
    } else {
      setNotificationState({
        ...NotificationState,
        StartDate: date,
        EndDate: "",
      });
      CheckValid(date, {
        type: "NotificationStartDate",
        error: seterrorStartDate,
      });
    }
  };

  // SELECT END DATE
  const DateEndGet = (date) => {
    if (date === null) {
      setNotificationState({
        ...NotificationState,
        EndDate: "",
      });
      CheckValid(date === null ? "" : date, {
        type: "NotificationEndDate",
        error: seterrorEndDate,
      });
    } else {
      setNotificationState({
        ...NotificationState,
        EndDate: date,
      });
      CheckValid(date, { type: "NotificationEndDate", error: seterrorEndDate });
    }
  };

  const UploadImage = async (e) => {
    const files = e.target.files[0];
    if (files) {
      setLoaderImage(true);
      const formDatas = new FormData();
      formDatas.append("file", files, files.name);
      const fileresponse = await UploadFileAPI(accessToken, formDatas);
      if (fileresponse?.status === 200) {
        setNotificationState({
          ...NotificationState,
          UploadedImage: fileresponse?.id,
          UploadedImageName: fileresponse?.name,
        });

        CheckValid(fileresponse, {
          type: "NotificationUploadedImage",
          error: seterrorUploadedImage,
        });

        setTimeout(() => {}, 1000);
        document.getElementById("fileInput").value = null;
      } else {
        setNotificationState({
          ...NotificationState,
          UploadedImage: "",
          UploadedImageName: "",
        });

        CheckValid("", {
          type: "NotificationUploadedImage",
          error: seterrorUploadedImage,
        });
      }
    }
  };

  // useEffect(() => {
  //   if (
  //     ClearFormSet?.action === 200 &&
  //     (ClearFormSet?.url === "add_marketing_campaign" ||
  //       ClearFormSet?.url === "update_marketing_campaign")
  //   ) {
  //     Navigate(OFFER_SCHEME_URL);
  //   }
  // }, [ClearFormSet]);
  const CreateNotificationsCMS = async (e) => {
    if (
      NotificationState?.Title !== "" &&
      NotificationState?.Description !== ""
    ) {
      let payload = {
        card_title: NotificationState?.Title,
        card_description: NotificationState?.Description,
        status: NotificationState?.Status,
        start_date: CommonDateTime(
          NotificationState?.StartDate,
          "YYYY-MM-DD",
          "hide",
        ),
        end_date: CommonDateTime(
          NotificationState?.EndDate,
          "YYYY-MM-DD",
          "hide",
        ),
        image: NotificationState?.UploadedImage,
        frequency_type: "daily",
        frequency_count: 1,
      };

      if (CurrentLocation === "edit-offer-scheme") {
        payload.offer_id= roomId;
        const response = await EditOfferSchemeAPI(payload, accessToken);
        if (response.status >= 400) {
          toast.error(response.message);
          return;
        }
        toast.success(response.message);
        Navigate(OFFER_SCHEME_URL);
      } else {
        const response = await CreateOfferSchemeAPI(payload, accessToken);

        if (response.status >= 400) {
          toast.error(response.message);
          return;
        }
        toast.success(response.message);
        Navigate(OFFER_SCHEME_URL);
      }
    } else {
      CheckValid(NotificationState?.Title, {
        type: "CampaignTitle",
        error: seterrorTitle,
      });
      CheckValid(NotificationState?.Description, {
        type: "CampaignDescription",
        error: seterrorDescription,
      });
    }
  };

  return (
    <section className="createApplcation_wrapper">
      <div className="MainHeader">
        <h4>
          {CurrentLocation === "edit-offer-scheme" ? "Edit" : "Create"} Campaign
        </h4>
        <Link to={OFFER_SCHEME_URL} className="btn btn-link backbtn">
          <i className="bi bi-arrow-left-short"></i> Back
        </Link>
      </div>
      <div className="tabsWrappersmAN">
        <CommonScrollBar
          className="ScrollbarsSidebar"
          height={{ height: "calc(100vh - 135px)" }}
        >
          <div className="formloginset mb-3">
            <div className="row">
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Card Title<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={NotificationState?.Title}
                    onChange={(e) =>
                      setNotificationState({
                        ...NotificationState,
                        Title: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "CampaignTitle",
                        error: seterrorTitle,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Card Title"
                  />
                  {errorTitle !== "" && (
                    <span className="error_medotory">{errorTitle}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Card Description<span className="mendatory_star">*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={NotificationState?.Description}
                    onChange={(e) =>
                      setNotificationState({
                        ...NotificationState,
                        Description: e.target.value,
                      })
                    }
                    onKeyUp={(e) =>
                      CheckValid(e.target.value, {
                        type: "CampaignDescription",
                        error: seterrorDescription,
                      })
                    }
                    onKeyDown={EmptySpaceFieldValid}
                    placeholder="Enter Card Description"
                  />
                  {errorDescription !== "" && (
                    <span className="error_medotory">{errorDescription}</span>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <CommonToggle
                  isBadgeAllow={true}
                  badgeTitle={"active_inactive"}
                  valueToggle={NotificationState?.Status}
                  setValueToggle={(e) =>
                    setNotificationState({
                      ...NotificationState,
                      Status: !NotificationState?.Status,
                    })
                  }
                  name={"Status"}
                />
              </div>
            </div>
          </div>
          <div
            className="formloginset mb-3"
            style={{
              borderBottom: "0px",
            }}
          >
            <div className="row">
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    Start Date<span className="mendatory_star">*</span>
                  </Form.Label>
                  <div className="datepickField min">
                    <DatePicker
                      selected={NotificationState?.StartDate}
                      onChange={(date) => DateStartGet(date)}
                      dateFormat="dd/MM/yyyy"
                      minDate={today}
                      placeholderText="Enter Start Date"
                      isClearable={NotificationState?.StartDate ? true : false}
                      autoComplete="off"
                    />
                  </div>
                  {errorStartDate && (
                    <small className="error_medotory">{errorStartDate}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    End Date<span className="mendatory_star">*</span>
                  </Form.Label>
                  <div className="datepickField">
                    <DatePicker
                      minDate={NotificationState?.StartDate}
                      selected={NotificationState?.EndDate}
                      onChange={(date) => DateEndGet(date)}
                      dateFormat="dd/MM/yyyy"
                      placeholderText="Enter End Date"
                      isClearable={NotificationState?.EndDate ? true : false}
                      name="ToDate"
                      autoComplete="off"
                    />
                  </div>
                  {errorEndDate && (
                    <small className="error_medotory">{errorEndDate}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Form.Label>Upload Image</Form.Label>
                  {NotificationState?.UploadedImageName === "" ? (
                    <div className="uploaded_image">
                      <label className="btn" id="upload_image_btn">
                        <input
                          type="file"
                          name="upload"
                          id="fileInput"
                          onChange={(e) => UploadImage(e)}
                          accept=".jpg, .jpeg, .png"
                        />
                        <img src={UploadFileIcon} alt="Upload" />
                        Upload Image
                      </label>
                      {LoaderImage && <Spinner />}
                    </div>
                  ) : (
                    <div className="image_upload_notifications_cmn">
                      {NotificationState?.UploadedImageName}
                      <img
                        src={DeleteIcon}
                        className="delete_btn"
                        onClick={() => {
                          setNotificationState({
                            ...NotificationState,
                            UploadedImage: "",
                            UploadedImageName: "",
                          });
                          CheckValid("", {
                            type: "NotificationUploadedImage",
                            error: seterrorUploadedImage,
                          });
                        }}
                        alt="edit"
                      />
                    </div>
                  )}
                  {errorUploadedImage && (
                    <small className="error_medotory">
                      {errorUploadedImage}
                    </small>
                  )}
                </Form.Group>
              </div>
            </div>
          </div>
          <button
            className="btn formbtn"
            style={{ width: "auto" }}
            onClick={CreateNotificationsCMS}
            variant="primary"
            type="button"
            // disabled={
            //   ClearFormSet?.action === 200 &&
            //   (ClearFormSet?.url === "add_marketing_campaign" ||
            //     ClearFormSet?.url === "update_marketing_campaign")
            // }
          >
            Submit
          </button>
        </CommonScrollBar>
      </div>
    </section>
  );
};

export default CreateOfferCampaigns;
